import React, { useContext, useEffect, useState } from 'react';
import axios from "axios";
import { Link, navigate } from "raviger";
import { Field, Form, Formik, } from 'formik';
import CloseButton from 'react-bootstrap/CloseButton';
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Form as BootstrapForm,
  ListGroup,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from 'react-bootstrap';
import {
  faArrowAltCircleLeft, faTimes, faCopy
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faQrcode,
} from '@fortawesome/pro-regular-svg-icons';
import * as Yup from 'yup';
import { DropDown } from '../components/Form';
import Moment from 'react-moment';
import Scrollbar from '../components/Scrollbars';
import { SystemErrorContext } from '../components/SystemError';
import { AuthContext } from "./AccountsReducer";
import Header from '../components/Header';
import { createQrCode } from '../utils/qrCode';
import { buildAccessQRPage } from './Utils';

const AccessManagement = ({ organization }) => {

  const { setShowSystemError } = useContext(SystemErrorContext);
  const { state } = useContext(AuthContext);

  const [showModal, setShowModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const [options, setOptions] = useState([]);

  const [data, setData] = useState({
    organization: state.organization.id,
    link_expires_at: new Date(new Date().setDate(new Date().getDate() + 7)).toISOString().split('T')[0],
    link_expires_at_options: 7,
    incident: null,
    // access_expires_at: new Date(new Date().setDate(new Date().getDate() + 6)).toISOString().split('T')[0],
    // access_expires_at_options: 7,
  })

  const [accessData, setAccessData] = useState([]);

  const [copiedId, setCopiedId] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const handleCopy = async (id, url) => {
    await navigator.clipboard.writeText(url);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 1500);
  };

  const handleDownloadQRClick = async (instance, url) => {
    setIsLoading(true)
    await new Promise(resolve => setTimeout(resolve, 0));
    buildAccessQRPage({instance: instance, accessUrl: url})
      .finally(() => setIsLoading(false));
  }

  const cancelTempAccess = (id) => {
    axios.delete('/incident/api/tempaccess/' + id + '/')
    setAccessData(accessData.filter(access => (access.id !== id)));
    setShowCancelModal('')
  }

  const grantAccess = (id) => {
    let values = {'access_request_ids':[id], 'organization': state.organization.id}
    axios.put('/accounts/api/user/approve_access/', values)
    .then(response => {
      let accessDataCopy = [...accessData];
      accessDataCopy.forEach(access_link => {
        access_link.access_requests = access_link.access_requests.filter(access => (access.id !== id))
      });
      setAccessData(accessDataCopy);
    })
    .catch(error => {
      setShowSystemError(true);
    });
  }

  const denyAccess = (id) => {
    axios.delete('/accounts/api/accessrequest/' + id + '/?organization=' + state.organization.id)
    .then(response => {
      let accessDataCopy = [...accessData];
      accessDataCopy.forEach(access_link => {
        access_link.access_requests = access_link.access_requests.filter(access => (access.id !== id))
      });
      setAccessData(accessDataCopy);
    })
    .catch(error => {
      setShowSystemError(true);
    });
  }

  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();
    if (state.user.is_superuser || state.user.user_perms) {
      const fetchTempAccess = async () => {
        // Fetch Temporary Access data.
        await axios.get('/incident/api/tempaccess/?organization=' + organization, {
          cancelToken: source.token,
        })
        .then(response => {
          if (!unmounted) {
            setAccessData(response.data);
          }
        })
        .catch(error => {
          if (!unmounted) {
            setShowSystemError(true);
          }
        });
      };
      fetchTempAccess();

      const fetchIncidentData = async () => {
        // Fetch Incident data.
        await axios.get('/incident/api/incident/?organization_slug=' + organization, {
          cancelToken: source.token,
        })
        .then(response => {
          if (!unmounted) {
            let options = [];
            response.data.forEach(inc => {
              // Build incident option list.
              if (!inc.end_time) {
                options.push({
                  value: inc.id,
                  label: inc.name,
                });
              }
            });
            setOptions(options);
          }
        })
        .catch(error => {
          if (!unmounted) {
            setShowSystemError(true);
          }
        });
      };
      fetchIncidentData();
    }
    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [organization]);

  return (
    <>
      {state.user.is_superuser || state.user.user_perms ? <span className="mt-3 ms-auto me-auto" style={{width:"80%", maxWidth:"80%"}}>
      <Header>
        <span style={{cursor:'pointer'}} onClick={() => navigate("/" + organization + '/manage/organization')} className="me-2"><FontAwesomeIcon icon={faArrowAltCircleLeft} size="sm" inverse /></span>
        {state.organization.name} - Manage Access
      </Header>
      <Card border="secondary" className="mt-1" style={{width:"35%", maxWidth:"35%"}}>
        <ButtonGroup>
          <Button
            type="button"
            className="btn btn-primary"
            onClick={() => { setShowAddModal(true) }}
            data-testid="save_button"
          >
            Create Access Link
          </Button>
        </ButtonGroup>
      </Card>
      <Formik
        initialValues={data}
        enableReinitialize={true}
        validationSchema={Yup.object({
          // access_expires_at: Yup.date().nullable(),
          link_expires_at: Yup.date(),
          incident: Yup.number().nullable()
            .required('Required'),
        })}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            values['organization'] = state.organization.id;
            axios.post('/incident/api/tempaccess/', values)
            .then(response => {
              setAccessData([...accessData, response.data]);
              setShowAddModal(false);
            })
            .catch(error => {
              setShowSystemError(true);
            });
            setSubmitting(false);
          }, 500);
        }}
      >
      {formikProps => (
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>New Access Link</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="mb-3">
              <Col xs="12">
                <Row>
                  <Col xs="8">
                    <DropDown
                      label="Incident"
                      id="incident"
                      name="incident"
                      options={options}
                      // onChange={(instance) => {
                      //   if (instance.value > 0) {
                      //     var access_date = new Date(new Date().setDate(new Date().getDate() + (instance.value - 1))).toISOString().split('T')[0];
                      //     formikProps.setFieldValue("access_expires_at", access_date)
                      //   }
                      //   else {
                      //     formikProps.setFieldValue("access_expires_at", null)
                      //   }
                      //   formikProps.setFieldValue("access_expires_at_options", instance.value)
                      // }}
                      isClearable={false}
                    />
                    {/* <DropDown
                      label="Access Expires In"
                      id="access_expires_at_options"
                      name="access_expires_at_options"
                      type="text"
                      options={[{value:0, label:'Never'}, {value:1, label:'1 day'}, {value:3, label:'3 days'}, {value:5, label:'5 days'}, {value:7, label:'7 days'}, {value:14, label:'14 days'}, {value:30, label:'30 days'}]}
                      onChange={(instance) => {
                        if (instance.value > 0) {
                          var access_date = new Date(new Date().setDate(new Date().getDate() + (instance.value - 1))).toISOString().split('T')[0];
                          formikProps.setFieldValue("access_expires_at", access_date)
                        }
                        else {
                          formikProps.setFieldValue("access_expires_at", null)
                        }
                        formikProps.setFieldValue("access_expires_at_options", instance.value)
                      }}
                      isClearable={false}
                    /> */}
                  </Col>
                  {/* <Col className="ms-0 ps-0" style={{fontSize:"24px", marginTop:"37px"}}>{formikProps.values.access_expires_at ? <span>on <Moment format="LL">{formikProps.values.access_expires_at}</Moment></span> : ""}</Col> */}
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <Row>
                  <Col xs="4">
                    <DropDown
                      label="Link Expires In"
                      id="link_expires_at_options"
                      name="link_expires_at_options"
                      type="text"
                      options={[{value:1, label:'1 day'}, {value:3, label:'3 days'}, {value:7, label:'7 days'}]}
                      onChange={(instance) => {
                        if (instance.value > 0) {
                          var access_date = new Date(new Date().setDate(new Date().getDate() + (instance.value))).toISOString().split('T')[0];
                          formikProps.setFieldValue("link_expires_at", access_date)
                        }
                        else {
                          formikProps.setFieldValue("link_expires_at", null)
                        }
                        formikProps.setFieldValue("link_expires_at_options", instance.value)
                      }}
                      isClearable={false}
                    />
                  </Col>
                  <Col className="ms-0 ps-0" style={{fontSize:"24px", marginTop:"37px"}}>on <Moment format="LL">{formikProps.values.link_expires_at}</Moment></Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => {formikProps.submitForm();}}>
            Save
          </Button>
          <Button variant="secondary" onClick={() => setShowAddModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    )}
    </Formik>
    {accessData.map(current_data => {

      const accessUrl = `${window.location.protocol}//${window.location.host}/${organization}/accounts/signup/${current_data.id.replaceAll('-', '')}`;
      return (
      <div key={current_data.id} className="row mt-3">
        <div className="col-10 d-flex">
          <Card className="border rounded d-flex" style={{width:"100%"}}>
            <Card.Body>
              <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px", marginLeft:"-15px"}}>
                <ListGroup.Item>
                  <Row>
                    <Col xs="6">
                      <span><b>Incident: </b>{current_data.incident_name}</span>
                      {/* <span><b>Access Expires On: </b>{current_data.access_expires_at ? <Moment format="LL">{current_data.access_expires_at}</Moment> : "Never"}</span> */}
                    </Col>
                    <Col xs={5} className="p-0">
                      <span><b>Link Expires On: </b><Moment format="LL">{current_data.link_expires_at}</Moment></span>
                    </Col>
                    <Col xs={1} style={{paddingRight:"0px"}}>
                      <OverlayTrigger
                        key={"cancel-temp-access"}
                        placement="bottom"
                        overlay={
                          <Tooltip id={`tooltip-cancel-temp-access`}>
                            Cancel temporary access registration
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon icon={faTimes} className="float-end" size="lg" onClick={() => {setShowCancelModal(current_data.id);}} style={{cursor:'pointer'}} inverse />
                      </OverlayTrigger>
                    </Col>
                  </Row>
                </ListGroup.Item>
                <ListGroup.Item>
                  <span>
                    <b>URL: </b>{accessUrl}
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip>
                            {copiedId === current_data.id ? "Copied!" : "Copy URL"}
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon
                          icon={faCopy}
                          className="ms-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleCopy(current_data.id, accessUrl)}
                          inverse
                        />
                      </OverlayTrigger>
                    <OverlayTrigger
                      key={"view-qrcode"}
                      placement="bottom"
                      overlay={
                        <Tooltip id={`tooltip-view-qrcode`}>
                          View QRcode
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faQrcode} className="ms-2" onClick={() => {handleDownloadQRClick(current_data, accessUrl)}} style={{cursor:'pointer'}} inverse />
                    </OverlayTrigger>
                  </span>
                </ListGroup.Item>
              </ListGroup>
              <hr/>
              <h4 style={{marginTop:"-5px"}}>Access Requests</h4>
              {current_data.access_requests.length > 0 ? <Scrollbar style={{height:"144px"}} renderThumbHorizontal={props => <div {...props} style={{...props.style, display: 'none'}} />}>
                <ListGroup>
                {current_data.access_requests.map(access_request => (
                  <ListGroup.Item key={access_request.id}>
                    <span style={{marginLeft:"-5px"}}>{access_request.user_object.first_name + ' ' + access_request.user_object.last_name + ' ' + access_request.user_object.display_phone + ' - ' + access_request.user_object.email}</span>
                    <Button variant="danger" className="float-end border" style={{marginTop:"-7px", marginBottom:"-8px", marginRight:"-15px"}} onClick={() => {denyAccess(access_request.id)}}>Deny</Button>
                    <Button className="float-end border" style={{marginTop:"-7px", marginBottom:"-8px"}} onClick={() => {grantAccess(access_request.id)}}>Approve</Button>
                  </ListGroup.Item>
                ))}
                </ListGroup>
              </Scrollbar> : ""}
              {current_data.access_requests.length === 0 ? <ListGroup.Item>None</ListGroup.Item> : ""}
            </Card.Body>
          </Card>
        </div>
      </div>
      )
    })}
    <Modal show={showModal} onHide={() => setShowModal('')}>
      <Modal.Header closeButton>
        <Modal.Title>{state.organization.name} Access Link</Modal.Title>
      </Modal.Header>
      <Modal.Body><img src={createQrCode(showModal)} /></Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowModal('')}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
    <Modal show={showCancelModal} onHide={() => setShowCancelModal('')}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Temporary Access Cancelation</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure you want to cancel this Temporary Access link?</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => cancelTempAccess(showCancelModal)}>
          Yes
        </Button>
        <Button variant="secondary" onClick={() => setShowCancelModal('')}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
    </span> : ""}
    </>
  );
};

export default AccessManagement;
